module.exports = __webpack_public_path__ + "static/media/qsdfqsdf.180e97f1.jpg";